import React, { useState, useEffect } from 'react';
import { Space, Input, Select } from 'antd';
import { getFirestore, collection, addDoc, doc, updateDoc, getDoc, getDocs } from "firebase/firestore";
import { showSuccessNotification, showWarningNotification, showErrorNotification } from '../../../utils/notifications';
import MediumModal from '../../../components/Components/Modals/MediumModal';

function CreateNewTag({
    isVisible,
    onClose,
    productId,
    productData
}) {
    const [newTagData, setNewTagData] = useState({
        group: '',
        name: ''
    });

    const [currentProductData, setCurrentProductData] = useState(productData);
    const [existingGroups, setExistingGroups] = useState([]);
    const [loading, setLoading] = useState(false);

    const db = getFirestore();

    // Aggiorna i dati del prodotto quando cambiano
    useEffect(() => {
        setCurrentProductData(productData);
    }, [productData]);

    // Carica i gruppi esistenti da Firebase
    useEffect(() => {
        const fetchExistingGroups = async () => {
            setLoading(true);
            try {
                const tagsSnapshot = await getDocs(collection(db, "Tags"));
                const groups = [];

                tagsSnapshot.forEach(doc => {
                    const tagData = doc.data();
                    if (tagData.group && !groups.includes(tagData.group)) {
                        groups.push(tagData.group);
                    }
                });

                setExistingGroups(groups.sort());
            } catch (error) {
                console.error("Error in loading existing groups:", error);
                showErrorNotification("Error", "Unable to load existing groups");
            } finally {
                setLoading(false);
            }
        };

        if (isVisible) {
            fetchExistingGroups();
        }
    }, [db, isVisible]);

    // Resetta i dati del form quando la modale viene chiusa
    const handleModalClose = () => {
        setNewTagData({
            group: '',
            name: ''
        });
        onClose(false);
    };

    // Funzione per gestire la creazione del nuovo tag
    const handleCreateTag = async () => {
        try {
            // Validazione dei campi
            if (!newTagData.group || !newTagData.name) {
                showWarningNotification("Attenzione", "Tutti i campi sono obbligatori");
                return;
            }

            // Crea il nuovo Tags
            const newTagRef = await addDoc(collection(db, "Tags"), {
                ...newTagData
            });

            // Ottieni i dati più recenti del prodotto
            const productRef = doc(db, "Products", productId);
            const productSnapshot = await getDoc(productRef);

            if (productSnapshot.exists()) {
                const freshProductData = productSnapshot.data();
                const currentCategories = freshProductData.list_tags || [];

                // Aggiungi l'ID del nuovo tag alla list_tags del prodotto
                const updatedCategories = [...currentCategories, newTagRef.id];
                await updateDoc(productRef, { list_tags: updatedCategories });

                showSuccessNotification("Save successful", "Tag created and added successfully!");
            } else {
                showErrorNotification("Error", "Product not found");
                return;
            }

            // Resetta i dati del form
            setNewTagData({
                group: '',
                name: ''
            });

            // Chiudi la modale e notifica il componente padre dell'aggiornamento
            onClose(true);
        } catch (error) {
            console.error("Error in creating the tag:", error);
            showErrorNotification("Error", "Error in creating the tag");
        }
    };

    return (
        <MediumModal
            title="Create New Tag"
            visible={isVisible}
            onClose={handleModalClose}
            onConfirm={handleCreateTag}
            confirmText="Create"
            cancelText="Cancel"
            width={700}
        >
            <Space direction="vertical" style={{ width: '100%' }} size="large">
                <div>
                    <label>Group:</label>
                    <Select
                        value={newTagData.group || undefined}
                        onChange={value => setNewTagData(prev => ({ ...prev, group: value }))}
                        placeholder="Select or create a group"
                        loading={loading}
                        style={{ width: '100%' }}
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={existingGroups.map(group => ({ value: group, label: group }))}
                    />
                </div>

                <div>
                    <label>Name:</label>
                    <Input
                        value={newTagData.name}
                        onChange={e => setNewTagData(prev => ({ ...prev, name: e.target.value }))}
                        placeholder="Insert tag name"
                    />
                </div>


            </Space>
        </MediumModal>
    );
}

export default CreateNewTag;